import React, { useEffect } from 'react'
import { useRequest } from 'ahooks'
import moment from 'moment'
import classnames from 'classnames'

import ToScreamFooter from '@scream/components/ToScreamFooter'

import { getScreamNumber } from '@scream/utils/math'
import { getLocationVars } from '@/utils/utils'
import { createBookSharePageUrl } from '@scream/utils/url'

import headerLogo from '@scream/assets/logos/icon_scream.png'
import defaultAvator from './assets/default_avatar.png'
import femaleIcon from './assets/icon_famale.png'
import maleIcon from './assets/icon_male.png'
import './App.scss'

import { getUserData } from '@scream/services/shareBookPage'

interface IBook {
  book_title: string
  book_pic: string
  book_id: string
  read_count: number
  chapter_count: number
}

const urlQueryParams = getLocationVars()

const renderGenderTag = (sex: 0 | 1 | 2) => {
  if (sex === 0) return null
  return (
    <div className='author-tag'>
      {sex === 1 ? <img src={maleIcon} /> : <img src={femaleIcon} />}
      <div>{sex === 1 ? 'male' : 'female'}</div>
    </div>
  )
}

// YYYY-MM-DD
const renderBirthdayTag = (birthdayStr: string) => {
  if (!birthdayStr) return null
  if (!moment(birthdayStr).isValid()) return console.log('生日格式有问题')
  const age = moment().diff(moment(birthdayStr), 'years')
  return <div className='author-tag'>{`${age} years old`}</div>
}

const App: React.FC = () => {
  const { uid }: { uid: string } = getLocationVars()

  const { data, error, loading } = useRequest(() => getUserData({ uid }), {
    onSuccess: (res) => {
      // if (res.code === 0) reportData(1)
    }
  })

  const bookList = data?.data?.books?.list || []
  const authorInfo = data?.data?.userInfo

  useEffect(() => {
    document.title = authorInfo?.uname || 'Author'
  }, [authorInfo?.uname])

  if (!uid) return <>Error: Required parameter uid missing</>
  if (loading) return null
  if (!authorInfo || !authorInfo.id) return <>Error: No userinfo.</>
  if (error) return <>An error has occurred, please try again</>
  if (data?.code !== 0) return <>{JSON.stringify(data?.msg)}</>

  const authorData = [
    { title: 'Followers', number: authorInfo.fans_num },
    { title: 'Visitors', number: authorInfo.visitor_num },
    { title: 'Following', number: authorInfo.follow_num }
  ]

  // 跳转到书籍详情页
  const pushToBookPage = (bookData: any) => {
    const {
      randomId,
      type,
      pushType
    }: { randomId: string; type: number; pushType: number } = getLocationVars()

    window.location.href = `../shareBookPage/?${createBookSharePageUrl({
      bookId: bookData.book_id,
      type: 1001,
      pushType: 1,
      randomId
    })}`
  }
  return (
    <div className='page-ctr'>
      <header>
        <img src={headerLogo} alt='' />
      </header>
      <div className='author-desc-img-ctr'></div>
      <div className='author-content'>
        <div className='avatar-ctr'>
          <div className='avatar-box'>
            <img src={authorInfo.pic || defaultAvator} id='avator' alt='' />
          </div>

          {authorInfo.is_author && (
            <div className='author-badge'>
              <span>Author</span>
            </div>
          )}
        </div>
        <div className='author-name'>{authorInfo.uname}</div>
        {(authorInfo.usex_set === 1 || authorInfo.birthday_set === 1) && (
          <div className='author-tags'>
            {authorInfo.usex_set === 1 && renderGenderTag(authorInfo.usex)}
            {authorInfo.birthday_set === 1 &&
              renderBirthdayTag(authorInfo.birthday)}
          </div>
        )}
        {authorInfo.about_me && (
          <div className='author-description'>{authorInfo.about_me}</div>
        )}
      </div>
      <div className='author-data-ctr'>
        {authorData.map((item) => (
          <div className='author-data-box' key={item.title}>
            <div className='data-number'>{getScreamNumber(item.number)}</div>
            <div className='data-title'>{item.title}</div>
          </div>
        ))}
      </div>
      <div
        style={{ width: '100vw', height: '.18rem', background: '#f5f5f5' }}
      ></div>
      {bookList.length > 0 ? (
        <div className='book-list-ctr'>
          <div className='book-list-title'>
            Stories <span>({bookList.length > 0 && bookList.length})</span>
          </div>
          <div className='book-list'>
            {bookList.map((book: IBook, idx: number) => (
              <div
                key={book.book_id}
                className={classnames({
                  'book-item': true,
                  'book-item-hot': idx < 3
                })}
                onClick={() => pushToBookPage(book)}
              >
                <div className='book-cover-box'>
                  <img src={book?.book_pic} alt={book.book_title} />
                  <div className='book-data-ctr'>
                    <div className='chapter-number'>{book.chapter_count}</div>
                    <div className='read-number'>
                      {getScreamNumber(book.read_count)}
                    </div>
                  </div>
                </div>
                <div className='book-title'>{book.book_title}</div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className='no-book-desc-ctr'>Currently no book.</div>
      )}
      <ToScreamFooter
        screamLinkData={urlQueryParams}
        customParamsDic={{ parm1: 'uid' }}
      ></ToScreamFooter>
    </div>
  )
}

export default App
